import React, { useEffect, useState } from 'react'
import './app-menu.scss'
import useMediaQuery from '@/utils/useMediaQuery'

export const NavLink = ({
  className,
  href,
  children,
  id,
  onClick,
}: {
  className: string
  href: string
  children: React.ReactNode
  id?: string
  onClick: () => void
}) => {
  return (
    <li className={'f-app-menu__list__item ' + className}>
      <a
        onClick={onClick}
        href={href}
        data-tag="6A"
        className="btn --btn-url"
        id={id}
      >
        {children}
      </a>
    </li>
  )
}
function UlLinkMenu({
  links,
  onClick,
}: {
  links: Record<string, string>
  onClick?: (key: string) => void
}) {
  const [hash, setHash] = useState('')
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const onHashListener = () => {
      setHash(window.location.hash)
      if (window.location.hash.length === 0) {
        return
      }
      let element: HTMLElement | null = document.querySelector(
        window.location.hash
      )
      if (element) {
        document?.scrollingElement?.scroll(0, element.offsetTop - 60)
      }
    }
    window.addEventListener('hashchange', onHashListener, false)
    onHashListener()
    return () => {
      window.removeEventListener('hashchange', onHashListener)
    }
  }, [])

  return (
    <ul className={'f-app-menu__list '}>
      {Object.keys(links).map(key => {
        return (
          <NavLink
            className={hash === '#' + key ? ' --active' : ''}
            href={'#' + key}
            key={key}
            onClick={() => {
              onClick && onClick(key)
            }}
          >
            {links[key]}
          </NavLink>
        )
      })}
    </ul>
  )
}
function MobileMenu({ links }: { links: Record<string, string> }) {
  const [open, setOpen] = useState(false)
  const onClickHandler = () => {
    setOpen(!open)
  }
  return (
    <>
      <div className={'f-app-menu__mobile-card ' + (open ? '--open' : '')}>
        <a className="close-btn" onClick={onClickHandler}></a>
        <UlLinkMenu links={links} onClick={onClickHandler} />
      </div>
      <div className="f-app-menu__mobile">
        <a className="burger-btn" onClick={onClickHandler}></a>
      </div>
    </>
  )
}
const AppMenu = ({ links }: { links: Record<string, string> }) => {
  const isMobile = useMediaQuery()
  if (!links) {
    links = { inicio: '/' }
  }

  return (
    <nav className="f-app-menu ">
      {isMobile ? <MobileMenu links={links} /> : <UlLinkMenu links={links} />}
    </nav>
  )
}

export default AppMenu
